import React from 'react';
import Icon from '../AppIcon';

const BulkActions = ({ selectedCount, onMessage, onReveal, onArchive, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-white border border-gray-200 rounded-xl shadow-xl p-4 z-50">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} color="#3b82f6" />
          <span className="text-sm font-medium text-gray-700">
            {selectedCount} selected
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onMessage}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            <Icon name="MessageSquare" size={16} />
            Message
          </button>
          <button
            onClick={onReveal}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            <Icon name="Shield" size={16} />
            Reveal
          </button>
          <button
            onClick={onArchive}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
          >
            <Icon name="Archive" size={16} />
            Archive
          </button>
          <button
            onClick={onClearSelection}
            className="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium rounded-lg transition-colors"
          >
            <Icon name="X" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;